import {qs, qsArray, trackEvent} from './utilities/index';

let Intro = function (params) {
  let intro = this;
  let introEl = params.el;
  let contentCTA = qs('.content-cta', introEl);
  let startButton = qs('button', contentCTA);
  let contentLoader = qs('.content-loader', introEl);
  let loaderBar = qs('.loader-bar', contentLoader);
  let dataBgSrcElements = qsArray('[data-bg-src]');
  let loadCount = 0;
  let timeline = null;
  let loadQueue = [
    '../assets/images/common/slider.' + (Modernizr.webp ? 'webp' : 'png')
  ];

  // grab background sources from data attributes in the html
  // determine whether to load their original file format or webp
  dataBgSrcElements.forEach(function(el){
    let src = el.getAttribute('data-bg-src');
    el.removeAttribute('data-bg-src');

    if (Modernizr.webp) {
      src = src.substr(0, src.lastIndexOf('.')) + '.webp';
    }
    el.style.backgroundImage = 'url("' + src + '")';

    if (loadQueue.indexOf(src) === -1) {
      loadQueue.push(src);
    }
  });

  // console.log(loadQueue);
  // console.log(loaderBar);

  // start loading
  loadQueue.forEach(function(src) {
    // console.log(src);
    let img = new Image();
    img.src = src;
    img.addEventListener('load', imgLoaded);
    img.addEventListener('error', imgLoadError);
  });

  function imgLoaded() {
    loadCount++;
    let progress = loadCount / loadQueue.length;
    loaderBar.style.transform = 'scaleX(' + progress + ')';
    if (loadCount === loadQueue.length) {
      loadComplete();
    }
  }

  function imgLoadError(e) {
    console.warn('Image Load Error', e);
  }

  function loadComplete(){
    setTimeout(function () {
      introEl.classList.add('load-complete');
    }, 250); // artificial delay so the load bar can make it to 100%
  }

  startButton.addEventListener('click', function () {
    trackEvent('intro', 'start');
    params.cb();
    startButton.blur();
  });

  // question public methods
  this.showInstant = function () {
    introEl.classList.add('is-active');
  }

  this.show = function(cb) {
    clearTimeline();
    TweenLite.set([introEl], { opacity: 0 });
    introEl.classList.add('is-active');
    timeline = new TimelineLite({
      onComplete: function() {
      if (cb) {
        cb();
      }
    }});
    timeline.to([introEl], 1, { opacity: 1 });
  }

  this.hide = function(cb) {
    clearTimeline();
    introEl.classList.add('is-disabled');
    timeline = new TimelineLite({ onComplete: function() {
      introEl.classList.remove('is-active');
      introEl.classList.remove('is-disabled');
      if (cb) {
        cb();
      }
    }});
    timeline.to([introEl], 0.25, { opacity: 0 });
  }

  function clearTimeline() {
    if (timeline) {
      timeline.kill();
      timeline = null;
    }
  }

}

export default Intro;
